module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/recap.json
// module id = 345
// module chunks = 272064664619550